import { useTranslation } from 'react-i18next';
// assets
import abcNews from 'public/static/images/trust_logos/abc-news.png';
import bloomberg from 'public/static/images/trust_logos/bloomberg.png';
import newYorkTimes from 'public/static/images/trust_logos/new-york-times.png';
import roadAndTrack from 'public/static/images/trust_logos/road-and-track.png';
import roadShow from 'public/static/images/trust_logos/road-show.png';
import usaToday from 'public/static/images/trust_logos/usa-today.png';

// styles
import { screen, colors } from './styles/variables';

function TrustLogos({ className }: { className?: string }): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={`trust-logos ${className}`}>
      <div className="title">{t('contentDashboard.featuredIn')}</div>
      <ul className="logos-list">
        <li className="logo">
          <img className="trust-logo-img" alt="Bloomberg" src={bloomberg} />
        </li>
        <li className="logo">
          <img className="trust-logo-img" alt="USA Today" src={usaToday} />
        </li>
        <li className="logo">
          <img className="trust-logo-img" alt="New York Times" src={newYorkTimes} />
        </li>
        <li className="break"></li>
        <li className="logo">
          <img className="trust-logo-img" alt="Road and Track" src={roadAndTrack} />
        </li>
        <li className="logo">
          <img className="trust-logo-img" alt="ABC News" src={abcNews} />
        </li>
        <li className="logo">
          <img className="trust-logo-img" alt="Road Show" src={roadShow} />
        </li>
      </ul>

      <style jsx>
        {`
          .trust-logos {
            width: 100%;
          }

          .title {
            color: ${colors.WHITE};
            font-weight: 600;
            font-size: 12px;
            letter-spacing: 0.5px;
            text-transform: uppercase;
          }

          .logos-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            list-style-type: none;
            margin: 0;
            padding: 0;
          }

          .trust-logo-img {
            height: 100%;
          }

          .break {
            display: none;
          }

          @media (max-width: ${screen.xsMax}) {
            .trust-logos {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
            }

            .title {
              text-align: center;
              width: 100%;
            }

            .logos-list {
              width: 368px;
            }

            .logo {
              height: 38px;
            }

            .break {
              display: block;
              flex-basis: 100%;
              height: 0px;
            }
          }

          @media (min-width: ${screen.smMin}) {
            .logo {
              height: 40px;
            }
          }

          @media (min-width: ${screen.mdMin}) {
            .logo {
              height: 40px;
            }
          }

          @media (min-width: ${screen.lgMin}) {
            .logo {
              height: 56px;
            }
          }
        `}
      </style>
    </div>
  );
}

export default TrustLogos;
